/* Madam Muse: turn the "Color" option buttons into colour dots everywhere (PDP, quick add) using a name -> hex map,
   falling back to Shopify swatch data when present. Shows the colour name on hover / tap and next to the legend.
   Also paints .mm-dots__dot elements (product cards, search results). Re-runs after Horizon morphs. */
(function () {
  var MAP = window.mmColorMap || {"black":"#111111","onyx":"#1a1a1a","white":"#ffffff","nude":"#e6c9b3","beige":"#e6c9b3","tan":"#d2a679","caramel":"#b5764b","brown":"#7a4b2a","gray":"#c9c9c9","grey":"#c9c9c9","light gray":"#dcdcdc","pink":"#f2c7cf","blush":"#f2c7cf","soft pink":"#f6d3d8","red":"#b7261e","navy":"#1f2a44","blue":"#4a6fa5","green":"#4f7a5a","leopard":"#c9a06a","cream":"#f3ecdf"};
  var keys = Object.keys(MAP).sort(function (a, b) { return b.length - a.length; });
  function colourFor(name) {
    var n = (name || '').toLowerCase().trim();
    if (MAP[n]) return MAP[n];
    var k = keys.find(function (key) { return n.indexOf(key) > -1; });
    return k ? MAP[k] : null;
  }
  function updateName(fs) {
    var legend = fs.querySelector('legend'); if (!legend) return;
    var checked = fs.querySelector('input[type="radio"]:checked');
    var span = legend.querySelector('.mm-color-name');
    var next = checked ? checked.value : '';
    if (!span) { span = document.createElement('span'); span.className = 'mm-color-name'; span.textContent = next; legend.appendChild(span); return; }
    if (span.textContent !== next) span.textContent = next;
  }
  function paint(root) {
    (root || document).querySelectorAll('input[type="radio"][data-option-name]').forEach(function (input) {
      var opt = (input.dataset.optionName || '').toLowerCase();
      if (opt !== 'color' && opt !== 'colour') return;
      var label = input.closest('label'); if (!label) return;
      var fs = label.closest('fieldset');
      if (!label.dataset.mmPainted) {
        var c = colourFor(input.value); if (!c) return;
        label.dataset.mmPainted = '1';
        label.classList.add('mm-color-btn');
        label.style.setProperty('--mm-swatch', c);
        label.dataset.mmName = input.value;
        label.removeAttribute('title');
        label.addEventListener('touchstart', function () {
          label.classList.add('is-hint'); clearTimeout(label._mmT);
          label._mmT = setTimeout(function () { label.classList.remove('is-hint'); }, 1400);
        }, { passive: true });
        if (fs) fs.classList.add('mm-color-fieldset');
      }
      if (fs) updateName(fs);
    });
    (root || document).querySelectorAll('.mm-dots__dot:not([style])').forEach(function (d) {
      var wrap = d.closest('[data-mm-dots]'), local = null;
      if (wrap) { if (!wrap._mmMap) { try { wrap._mmMap = JSON.parse(wrap.getAttribute('data-mm-dots') || '{}'); } catch (e) { wrap._mmMap = {}; } } local = wrap._mmMap; }
      var n = (d.dataset.name || '').toLowerCase().trim(), hit = null;
      if (local) { hit = local[n]; if (!hit) { var k = Object.keys(local).find(function (key) { return n.indexOf(key.toLowerCase()) > -1; }); hit = k ? local[k] : null; } }
      d.style.backgroundColor = hit || colourFor(n) || '#d9d9d9';
    });
  }
  var SEL = 'input[type="radio"][data-option-name], .mm-dots__dot';
  paint();
  document.addEventListener('change', function (e) {
    var fs = e.target && e.target.closest ? e.target.closest('fieldset.mm-color-fieldset') : null;
    if (fs) updateName(fs);
  });
  var pending = [], scheduled = false;
  function flush() { scheduled = false; var list = pending; pending = []; list.forEach(function (n) { if (n.isConnected) paint(n); }); }
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var m = muts[i];
      if (m.type === 'attributes') {
        /* Horizon's morph re-syncs attributes from server HTML and strips our style/class: repaint that node */
        var t = m.target;
        if (t.nodeType !== 1) continue;
        if ((t.classList.contains('mm-dots__dot') && !t.getAttribute('style')) || (t.tagName === 'LABEL' && !t.dataset.mmPainted && t.querySelector('input[data-option-name]'))) { pending.push(t.parentNode || t); }
        continue;
      }
      var added = m.addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if (n.matches(SEL) || n.querySelector(SEL)) { pending.push(n.matches(SEL) ? n.parentNode : n); }
      }
    }
    if (pending.length && !scheduled) { scheduled = true; setTimeout(flush, 32); }
  });
  /* perf: no 'class' - a morph that strips our paint also drops data-mm-painted (and dots lose style), so class changes
     (sliders, video wall, header states fire them constantly) never need a callback */
  mo.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'data-mm-painted'] });
})();

/* Lazy video posters: <video data-poster> gets its poster when it comes within 400px of the viewport (the UGC wall handles its own). */
(function () {
  function arm() {
    var vids = Array.prototype.slice.call(document.querySelectorAll('video[data-poster]')).filter(function (v) { return !v.closest('[data-mm-vwall]') && !v._mmLazy; });
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) { vids.forEach(function (v) { v.poster = v.dataset.poster; }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.poster = e.target.dataset.poster; io.unobserve(e.target); } });
    }, { rootMargin: '400px 0px' });
    vids.forEach(function (v) { v._mmLazy = true; io.observe(v); });
  }
  arm();
  document.addEventListener('DOMContentLoaded', arm);
  /* perf: one rescan per burst of DOM changes (was a full video query on every mutation batch) */
  var armQueued = false;
  new MutationObserver(function (m) {
    if (armQueued) return;
    for (var i = 0; i < m.length; i++) { if (m[i].addedNodes.length) { armQueued = true; setTimeout(function () { armQueued = false; arm(); }, 250); break; } }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* Card colour dots (blocks/mm-color-dots.liquid): pick a colour -> swap the card image. One delegated capture listener
   (runs before the card's own click-to-product handler, which the old per-card inline script stopped the same way). */
(function () {
  document.addEventListener('click', function (e) {
    var dot = e.target && e.target.closest ? e.target.closest('[data-mm-swatch]') : null;
    if (!dot) return;
    var root = dot.closest('.mm-dots'); if (!root) return;
    e.preventDefault();
    e.stopPropagation();
    root.querySelectorAll('[data-mm-swatch]').forEach(function (d) {
      d.classList.toggle('is-selected', d === dot);
      d.setAttribute('aria-pressed', d === dot ? 'true' : 'false');
    });
    var card = root.closest('product-card, .product-card, [class*="product-card"]');
    var img = card ? card.querySelector('.card-gallery img') : null;
    if (!img || !dot.dataset.image) return;
    img.src = dot.dataset.image;
    if (dot.dataset.image2x) img.srcset = dot.dataset.image + ' 1x, ' + dot.dataset.image2x + ' 2x';
    else img.removeAttribute('srcset');
  }, true);
})();
